/**
 * Mise en forme d'une place occupée sur le disque, en octets, pour l'affichage.
 *
 * L'unité suit la taille : un son de 4 Mo et une vidéo transcodée de 22 Go ne se
 * lisent pas dans la même échelle. On garde une décimale en Mo et deux en Go,
 * assez pour distinguer deux médias voisins sans donner un chiffre faussement
 * précis.
 *
 * `computedAt` porte la seule information qui manque au nombre : la mesure
 * a-t-elle eu lieu ? `storageBytes` vaut 0 aussi bien pour un média jamais mesuré
 * que pour un média réellement vide — afficher « 0 o » dans le premier cas
 * ferait passer une absence de mesure pour un fait. On affiche un tiret.
 */
export const formatStorageSize = ( bytes: number, computedAt: Date | null = null ): string => {

  if ( computedAt === null )       return '—';
  if ( ! isFinite(bytes) )         return '—';
  if ( bytes <= 0 )                return '0 o';
  if ( bytes < 1024 )              return `${bytes} o`;
  if ( bytes < 1024 ** 2 )         return `${(bytes / 1024).toFixed(0)} Ko`;
  if ( bytes < 1024 ** 3 )         return `${(bytes / 1024 ** 2).toFixed(2)} Mo`;

  return `${(bytes / 1024 ** 3).toFixed(2)} Go`;
};
